import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-facility-edit-location",
	templateUrl: "./facility-edit-location.component.html",
	styleUrls: ["./facility-edit-location.component.css"],
})
export class FacilityEditLocationComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.SelectedLocations = this.dialogConfig.data.SelectedLocations;
		this.lstLocations = this.dialogConfig.data.lstLocations;

		//Remove selected from lst
		this.lstLocations = this.lstLocations.filter((location) => this.SelectedLocations.indexOf(location) == -1);

		this.Code = this.SelectedLocations[0].FacilityLocationCD;
		this.Name = this.SelectedLocations[0].FacilityLocationName;
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////
	SelectedLocations: any;
	lstLocations: any = [];
	Code: any = "";
	Name: any = "";
	errorMessage: any = "";
	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////
	onAdd() {
		this.errorMessage = "";

		//Error handling
		if (this.Code == "") {
			this.errorMessage = "Enter a Location Code";
			return;
		}
		if (this.Name == "") {
			this.errorMessage = "Enter a Location Name";
			return;
		}

		for (var i = 0; i < this.lstLocations.length; i++) {
			var next = this.lstLocations[i];
			if (next.FacilityLocationCD == this.Code) {
				this.errorMessage = "Location Code Already Taken";
				return;
			}
		}

		let myData: any = {
			FacilityLocationCD: this.Code,
			FacilityLocationName: this.Name,
			ActiveDesc: this.SelectedLocations[0].ActiveDesc,
		};

		this.ref.close(myData);
	}
	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////
}
